import {sha256Hex} from "./utils";

export async function calculateIntegrityHash(map: { [key: string]: any }): Promise<string> {
  const serialized = Object.keys(map)
    .sort()
    .map(key => `${key}=${serializeValue(map[key])}`)
    .join(", ");
  return sha256Hex(serialized);
}

function serializeValue(value: any): string {
  if (value === null || value === undefined) return "null";
  if (Array.isArray(value)) return `[${value.join(", ")}]`;
  return String(value);
}
